export enum MetaState {
  initial = 'initial',
  loading = 'loading',
  success = 'success',
  failed = 'failed',
}
